import {UserPost} from "../../types/domain.ts";
import {baseRequestService} from "../base.ts";

export const usersPost = (data: UserPost) => baseRequestService({
    url: '/users',
    method: 'POST',
    data
});